import { AppState } from '@store/state';
import { ChangedFlightPost, SelectedFlightResponse } from './_interfaces_/change-flight-confirmation.interface';
import { ErrorModalModel } from '@store/error-modal/error-modal.model';
import { ErrorResponseCheck } from 'src/app/core/factories/change-api-array-error/change-api-array-error';
import {
  FlightChangeApiResponse,
  RetrivedFlightLinkResponse,
  RetrivedFlightResponseError,
} from '@shared/services/flight/_interfaces_/booked-flight.interface';
import { FlightChangeFlagModel } from '@store/changed-flight-state/changed-flight-state.model';
import { hasIn } from 'lodash';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@shared/services/local-storage/local-storage.service';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { take, switchMap, map } from 'rxjs/operators';
import { UrlService } from '@shared/services/url/url.service';
import * as changeFlightStateActions from '@store/changed-flight-state/changed-flight-state.actions';
import * as errorModalActions from '@store/error-modal/error-modal.actions';

@Injectable({
  providedIn: 'root',
})
export class ChangeFlightConfirmationService {
  private userSessionId: string;
  public selectedFlightResponse: SelectedFlightResponse;

  constructor(
    @Inject(HttpClient) private httpClient: HttpClient,
    @Inject(UrlService) private _urlService: UrlService,
    @Inject(Store) private _store: Store<AppState>,
    @Inject(LocalStorageService) private _localStorageService: LocalStorageService
  ) {
    this.userSessionId = this._localStorageService.getUserSessionToken();
  }

  public setFlightConfirmedFlag() {
    this._store.dispatch(changeFlightStateActions.setChangedFlightFlagState({ wasFlightChangeConfirmed: true } as FlightChangeFlagModel));
  }

  public getSelectedFlightResponse(): Observable<SelectedFlightResponse> {
    return of(this.selectedFlightResponse);
  }

  public postChangedFlight(selectedFlightIdentifier: string): Observable<boolean> {
    const url = this._urlService.urls.POST_CHANGED_FLIGHT;
    const payload = { selectedFlightIdentifier: selectedFlightIdentifier } as ChangedFlightPost;
    const headers = { SessionId: this.userSessionId };

    return this.httpClient.post<RetrivedFlightLinkResponse>(url, payload, { headers }).pipe(
      take(1),
      map((response?: SelectedFlightResponse) => {
        this._localStorageService.setChangedFlightUrl(response?.links[0]?.url);
        this.setFlightConfirmedFlag();
        return false;
      })
    );
  }
}
